/**
 * @file Locks a control while its request runs.
 */

/**
 * Disables a control while its request runs. Disabling drops the focus, which would leave a keyboard user stranded, so
 * the returned function enables the control again and puts the focus back.
 *
 * @param {HTMLInputElement|HTMLButtonElement} control
 * @returns {() => void} unlock
 */
export function lockControl(control) {
  const hadFocus = document.activeElement === control;
  control.disabled = true;

  return () => {
    control.disabled = false;
    if (hadFocus) {
      control.focus();
    }
  };
}
